import CoinList from './components/CoinList';
import './assets/css/app.min.css';

function App() {
  return (
    <CoinList/>
  )
}

export default App;